import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Nayrix</title>
      <meta name="description" content="Read Nayrix's privacy policy. We respect your privacy and do not collect or share your personal information." />
      <meta property="og:title" content="Privacy Policy | Nayrix" />
      <meta property="og:description" content="Read Nayrix's privacy policy. We respect your privacy and do not collect or share your personal information." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://nayrix.com/privacypolicy" />
      <link rel="canonical" href="https://nayrix.com/privacypolicy" />
    </Helmet>
    <div className="flex items-center justify-center min-h-[70vh] pt-16">
      <div className="w-full max-w-xl bg-white dark:bg-neutral-900 rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-lg text-neutral-600 dark:text-neutral-300">
          We respect your privacy. Nayrix does not collect or share your personal information. For any questions, please contact us.
        </p>
      </div>
    </div>
  </>
);

export default PrivacyPolicy; 